import { render, staticRenderFns } from "./SearchCandidates.vue?vue&type=template&id=1ffd04a4&scoped=true&"
import script from "./SearchCandidates.vue?vue&type=script&lang=js&"
export * from "./SearchCandidates.vue?vue&type=script&lang=js&"
import style0 from "./SearchCandidates.vue?vue&type=style&index=0&id=1ffd04a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd04a4",
  null
  
)

export default component.exports